import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './components/Homepage';
import AboutUs from './components/AboutUs';
import BlogPage from './components/BlogPage';
import BlogPostPage from './components/BlogPostPage';
import ServiceDetail from './components/ServiceDetail';
import AdminPanel from './components/AdminPanel';
import FormSuccess from './components/FormSuccess';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:id" element={<BlogPostPage />} />
          <Route path="/service/:slug" element={<ServiceDetail />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/form-success" element={<FormSuccess />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
